import clsx from 'clsx';
import {
  ScoreHealthRangeIndicatorElement,
  ScoreHealthRangeAcceptedDotElement,
  TargetScoreRangeGraphicElement,
} from '../types';

export interface ScoreHealthRangeGraphicProps {
  className?: string;
  numberOfSections?: number;
  targetScoreRangeGraphic?: TargetScoreRangeGraphicElement | boolean;
  scoreHealthRangeIndicator?: ScoreHealthRangeIndicatorElement | boolean;
  graphDots?: ScoreHealthRangeAcceptedDotElement | ScoreHealthRangeAcceptedDotElement[] | boolean;
}

export function ScoreHealthRangeGraphic({
  graphDots,
  className,
  numberOfSections,
  targetScoreRangeGraphic,
  scoreHealthRangeIndicator,
}: ScoreHealthRangeGraphicProps) {
  return (
    <div className={clsx(className, 'relative grid h-[22px] w-full grid-flow-col items-end gap-[3px]')}>
      {new Array(numberOfSections).fill(0).map((_, i) => (
        <div className="relative h-full flex flex-col justify-center" key={i}>
          <span
            className="ScoreHealthRangeGraphic-Line h-[3px] w-full bg-palette-600 last-of-type:rounded-full first-of-type:rounded-full"
            style={{ transform: 'matrix(-1, 0, 0, 1, 0, 0)' }}
          />
        </div>
      ))}
      {graphDots}
      {scoreHealthRangeIndicator}
      {targetScoreRangeGraphic}
    </div>
  );
}
